var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-table-header"},_vm._l((_vm.headers),function(header){return _c('div',{class:`custom-tr ${header.class} ${header.prop === 'actions' ? 'd-flex justify-content-center' : ''}`,style:(`min-width: ${header.minWidth}px;`)},[_c('p',[_vm._v(_vm._s(header.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }